<template>
  <popup ref="popup" :loading="popupLoading" :appendToBody="true">
    <div slot="body" class="tab-body">
      <div></div>
      <div class="dataTable autoFlex" v-if="listData">
        <el-table
          class="table"
          :data="listData"
          align="center"
          :header-cell-style="{ 'text-align': 'center' }"
          height="auto"
          v-loading="listLoading"
        >
          <el-table-column width="45px" prop="name" label="No">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column width="65px" prop="name" label="姓名">
          </el-table-column>
          <el-table-column width="65px" prop="post" label="岗位">
            <template slot-scope="scope">
              <el-tag type="danger" size="mini" v-if="scope.row.post == '前端'"
                >前端</el-tag
              >
              <el-tag type="warning" size="mini" v-if="scope.row.post == '后端'"
                >后端</el-tag
              >
              <el-tag size="mini" v-if="scope.row.post == '全栈'">全栈</el-tag>
            </template></el-table-column
          >
          <el-table-column width="130px" prop="mobile" label="手机">
            <template slot-scope="scope">
              <el-tag size="mini" type="info"> {{ scope.row.mobile }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column width="160px" prop="email" label="邮箱">
            <template slot-scope="scope">
              <el-tag size="mini" type="info"> {{ scope.row.email }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            width="95px"
            prop="type"
            label="类型"
          ></el-table-column>
          
          <el-table-column width="65px" prop="dyer" label="电邀">
          </el-table-column>
          <el-table-column width="65px" prop="zxer" label="咨询">
          </el-table-column>
          <el-table-column width="265px" prop="schoolid" label="学校&专业">
            <template slot-scope="scope">
              <el-tag size="mini" type="info"> {{ scope.row.schoolid }}</el-tag>
               <el-tag size="mini" type="info"> {{ scope.row.subject }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column width="95px" prop="gradedate" label="毕业年份">
          </el-table-column>
          <el-table-column width="65px" prop="rank" label="评级">
            <template slot-scope="scope">
              <el-tag type="danger" size="mini" v-if="scope.row.rank == 1"
                >D量</el-tag
              >
              <el-tag type="warning" size="mini" v-if="scope.row.rank == 2"
                >C量</el-tag
              >
              <el-tag size="mini" v-if="scope.row.rank == 3">B量</el-tag>
              <el-tag type="success" size="mini" v-if="scope.row.rank == 4"
                >A量</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="recruid"
            label="数据渠道平台"
            align="center"
            width="160px"
          >
             <template slot-scope="scope">
              <el-select v-model="scope.row.recruid" :disabled="true" placeholder="请选择">
                <el-option
                  v-for="item in qdaolist"
                  :key="item.name"
                  :label="item.name"
                  :value="item.id">
                </el-option>
             </el-select>
            </template>

          </el-table-column>
        </el-table>
  <el-card class="box-card">
  <div slot="header" class="clearfix">
    <span style="color:red;">{{titleErr}}</span>
  </div>
  <div v-for="o in errlist" :key="o" class="text item">
    {{ o }}
  </div>
</el-card>
      </div>
      <div slot="footer">
        <el-button @click="upload" type="success">{{ title }}</el-button>
        <el-button @click="close" type="danger">取消</el-button>
      </div>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/consu/consultationxl/consultationxl.js";

export default {
  name: "uploadlist",
  components: {
    popup,
  },
  data() {
    return {
      popupLoading: false,
      confirmLoading: false,
      listData: [],
      listLoading: false,
      title: "",
      qdaolist:[],
      errlist:[],
      titleErr: ""
    };
  },
  methods: {
    //打开弹框
    open(parameter, title) { 
      this.fname = parameter;
      this.title = title;

      this.listLoading = true;
      this.$refs.popup.open(title, "75%");

      this.$nextTick(() => {
        api.toPush({ fname : this.fname }, (response) => {
  
          this.listData = response.data.datas;
          this.qdaolist = response.data.qdaolist;
          this.errlist  = response.data.errs;

          this.titleErr ="   成功解析【 "+this.listData.length+" 】条, 失败的数据【 "+this.errlist.length +" 】条："
         
          this.listLoading = false;

        });
      });
    }, close() { //关闭弹框
          this.$refs.popup.close();
    }, upload(){

      api.importData(  this.listData  , ( res ) => {
            this.$alert(res.msg,  "导入成功(失败数据有可能是已存在)", {  confirmButtonText: "确定"  });
            this.$refs.popup.close();
            this.$emit("flush");
            this.listLoading = false;

          }, ( err ) => {
            this.$alert(msg,  "导入失败，请联系管理员。", {  confirmButtonText: "确定"  });
            this.listLoading = false;
        });

    }
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
